import React from "react";
import CommonUtil from "../../../../utils/CommonUtil";
import FilteringComponent from "../FilteringComponent";

class TreeComponent extends FilteringComponent {
  constructor(props) {
    super(props);

    this.treeRef = React.createRef();
  }

  initialState() {
    return {
      ...super.initialState(),
      loadedKeys: [],
      isLoading: true
    };
  }

  loop = (data, key, callback) => {
    data.forEach((item, index, arr) => {
      if (item.key === key) {
        return callback(item, index, arr);
      }
      if (item.children) {
        return this.loop(item.children, key, callback);
      }
    });
  };

  findParentOfNode(tree, nodeKey) {
    if (!tree) return undefined;

    for (const node of tree) {
      if (node.children === undefined) {
        continue;
      }
      let treeNodeData = node.children.find(item => item.key === nodeKey);
      if (treeNodeData) {
        return node;
      }
      treeNodeData = this.findParentOfNode(node.children, nodeKey);
      if (treeNodeData) {
        return treeNodeData;
      }
    }
  }

  onEmptyLoad() {}

  updateParent = (child, parent) => {
    throw new Error("Update parent must be implemented if draggable true!");
  };

  checkNodeCallback = (item, data) => {
    throw new Error(
      "checkNodeCallback must be implemented if using findInTree!"
    );
  };

  findInTree(tree, data) {
    if (!tree) return undefined;

    for (const node of tree) {
      if (node.children === undefined) {
        continue;
      }
      let treeNodeData = node.children.find(item =>
        this.checkNodeCallback(item, data)
      );
      if (treeNodeData) {
        return treeNodeData;
      }
      treeNodeData = this.findInTree(node.children, data);
      if (treeNodeData) {
        return treeNodeData;
      }
    }
  }

  findInTreeByKey(tree, key) {
    if (!tree) return undefined;

    for (const node of tree) {
      if (node.key === key) {
        return node;
      }
      if (node.children === undefined) {
        continue;
      }
      let treeNodeData = node.children.find(item => item.key === key);
      if (treeNodeData) {
        return treeNodeData;
      }
      treeNodeData = this.findInTreeByKey(node.children, key);
      if (treeNodeData) {
        return treeNodeData;
      }
    }
  }

  onDataLoad = (data, tree = this.state.content) => {
    //root nodes finding
    let treeNodeData = tree.find(item => this.checkNodeCallback(item, data));

    //nested nodes finding
    if (!treeNodeData) {
      treeNodeData = this.findInTree(tree, data);
    }

    if (!treeNodeData) return;

    if (tree === this.state.content) {
      this.state.loadedKeys.push(treeNodeData.key);
    }

    if (data._embedded) {
      const children = data._embedded.content.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: this.props.classificationsFilter
            ? this.props.classificationsFilter.includes(item.id)
            : true,
          disabled: false
        };
      });
      treeNodeData.children = children;
    } else {
      treeNodeData.leaf = true;
    }

    if (this._isMounted) {
      this.setState({
        loadedKeys: this.state.loadedKeys,
        content: [...this.state.content]
      });
    }
  };

  resetComponent() {
    this.state = this.initialState();
    this.setState({ ...this.state, searchValue: "" });
    super.resetComponent();
  }

  startLoading = (pageInfo, sortInfo) => {
    if (this.treeRef?.current) {
      this.treeRef.current.resetExpandedKeys();
    }
    const { searchValue } = this.state;
    if (searchValue && searchValue !== "") {
      this.loadEntitiesWithFilter(pageInfo);
    } else {
      this.loadRoots(pageInfo);
    }
  };

  onSearchChange = e => {
    const searchValue = e.target.value;
    this.state.searchValue = searchValue;
    this.state.pageInfo.number = 0;
    let pageInfo = this.state.pageInfo;
    pageInfo = this.createSearchInfo(searchValue, pageInfo);
    this.startLoading(pageInfo);
  };

  createSearchInfo = (searchValue, pageInfo) => {
    pageInfo.filters.name.filterVal = searchValue;
    return pageInfo;
  };

  loadEntitiesWithFilter = pageInfo => {
    throw new Error("loadWithFilter must be implemented");
  };

  loadData = expanded => {
    throw new Error("loadData must be implemented");
  };

  onLoadData = (treeNode, onLoadCallback) => {
    const isLoaded = this.state.loadedKeys.some(
      item => item === treeNode.props.dataRef.key
    );
    if (isLoaded) {
      return new Promise(resolve => {
        resolve();
        return;
      });
    }

    const expanded = treeNode.props.dataRef;
    return this.loadData(expanded, onLoadCallback);
  };

  onPageNumberClick = event => {
    const { pageInfo } = this.state;
    pageInfo.number = parseInt(event.target.id);
    this.startLoading(pageInfo);
  };

  onRootDataLoad = data => {
    const pageInfo = {
      ...data.page,
      filters: this.state.pageInfo.filters
    };
    const content = data._embedded
      ? data._embedded.content.map(item => {
          return {
            ...item,
            key: "" + item.id,
            selectable: true
          };
        })
      : [];
    if (this._isMounted) {
      this.setState({
        loadedKeys: [],
        content: content,
        links: data._links,
        pageInfo: pageInfo,
        isLoading: false
      });
    }
  };

  onLoadWithFilter = data => {
    const pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    let content = [];
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      content = dataContent.map(item => {
        return {
          ...item,
          key: "" + item.id,
          selectable: true,
          leaf: true
        };
      });
    }
    this.setState({
      loadedKeys: [],
      content: content,
      links: data._links,
      pageInfo: pageInfo
    });
  };

  loadRoots = pageInfo => {
    throw new Error("loadRoots should be implemented!");
  };

  onEntityLoad = data => {
    throw new Error("onEntityLoad should be implemented!");
  };

  loadSelectedEntity = selected => {
    throw new Error("loadSelectedEntity should be implemented!");
  };

  onSelect = nodes => {
    throw new Error("onSelect should be implemented if used!");
  };

  renderProps() {
    return {
      ...super.renderProps(),
      loadedKeys: this.state.loadedKeys,
      treeRef: this.treeRef,
      loadData: this.onLoadData,
      onPageNumberClick: this.onPageNumberClick
    };
  }
}

export default TreeComponent;
